var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsPageValidateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.501,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8533"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7634",
    d: "M9.887 8.947l.9.9a1.812 1.812 0 012.022.37l2.163 2.163a1.832 1.832 0 01-2.591 2.591l-2.166-2.162a1.813 1.813 0 01-.37-2.022l-.9-.9a5.535 5.535 0 11.939-.94zM8.506 2.56a4.2 4.2 0 100 5.946 4.2 4.2 0 000-5.946zm4.809 11.472a.483.483 0 00.679 0 .525.525 0 00.133-.18.483.483 0 00-.1-.532l-2.163-2.163a.482.482 0 00-.679 0 .49.49 0 00-.169.312.48.48 0 00.136.4z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsPageValidateIcon);
export default __webpack_public_path__ + "static/media/results-page-validate-icon.9a00039c4e844f224c479212ef12e907.svg";
export { ForwardRef as ReactComponent };